import React, { memo, useMemo } from 'react';
import classNames from 'classnames';
import { formGroup, formControl, FormDataType } from '@core/utils/form';
import { useNonNilObservable } from '@core/utils/hooks/rxjs';
import { useConfigureBlock } from '@modules/course/CourseBuilder/hooks';
import { Container } from 'reactstrap';
import { CommonService } from '@business/services';
import { R } from '@core/utils/r';
import { useCourseBuilderContext } from '@modules/course/CourseBuilder/CourseBuilderPage';
import { defineBlockAdvanceForm } from '../Common/AdvanceSettings';
import { CourseBuilder } from '../types';
import { BlockContainer } from '../BlockContainer';
import { JobDescriptionBlockSettings } from './JobDescriptionBlockSettings';
import { JobDescriptionComponent } from './JobDescriptionComponent';
import { TextBlock } from './JobDescriptionComponent';

function defineJobDescriptionBlockForm(variation: JobDescriptionBlockVariation) {
  return formGroup({
    heading: formControl<string>({ initialValue: '' }),
    text: formControl<string>({
      initialValue: `<ol><li>Vel magna iaculis arcu cursus parturient blandit suscipit taciti auctor maecenas.</li><li>Penatibus libero risus montes conubia pretium quisque ut fermentum, vulputate augue litora ornare fames turpis convallis imperdiet, curae etiam sed enim dictumst purus sit.</li><li>Tortor parturient gravida habitant dapibus et fusce felis nam nibh litora ridiculus aenean porttitor turpis pharetra.</li><li>Suscipit montes natoque aptent ex gravida orci ultrices volutpat nunc.</li></ol>`,
    }),
    id: formControl<string>({
      label: R.startCase(variation),
    }),
    advance: defineBlockAdvanceForm({ paddingTop: 0, paddingBottom: 0 }),
  });
}

export type JobDescriptionWidgetFormData = FormDataType<typeof defineJobDescriptionBlockForm>;
export type JobDescriptionWidgetForm = ReturnType<typeof defineJobDescriptionBlockForm>;

export enum JobDescriptionBlockVariation {
  jobDescription = 'jobDescription',
}

export const JobDescriptionBlock = memo((props: CourseBuilder.BlockProps<JobDescriptionBlockVariation>) => {
  const { variation } = props;
  const form = useMemo(() => defineJobDescriptionBlockForm(variation), [variation]);
  const formValue = useNonNilObservable(form.value$);
  const proposal = useCourseBuilderContext();

  const content = useMemo(() => {
    if (CommonService.isJson(formValue.text)) {
      return JSON.parse(formValue.text);
    }
    return [];
  }, [formValue.text]);

  const hasContent = useMemo(() => !!content.overview, [content]);

  useConfigureBlock({
    props,
    form,
    contentComponent: JobDescriptionBlockSettings,
    contentProps: { form, variation },
  });

  return (
    <BlockContainer className={classNames('d-flex flex-fill', 'block-list', variation)} advanceForm={formValue.advance}>
      <Container>
        {!hasContent && (
          <React.Fragment>
            <h3>Job Description</h3>
            <TextBlock title="Overview">Overview</TextBlock>
            <TextBlock title="Who You Report To">Who You Report To</TextBlock>
            <TextBlock title="Who Reports To You">Who Reports To You</TextBlock>
            <TextBlock title="Function Definitions"></TextBlock>
            <TextBlock title="Functions"></TextBlock>
            {/* {<TextBlock title="Education">Education</TextBlock>}
            {<TextBlock title="Experience">Experience</TextBlock>} */}
            {/* {<TextBlock title="Skills">Skills</TextBlock>}
            {<TextBlock title="Physical Requirements">Physical Requirements</TextBlock>} */}
          </React.Fragment>
        )}
        {hasContent && <JobDescriptionComponent content={content as any} title={formValue.heading} />}
      </Container>
    </BlockContainer>
  );
});
